function addProductStepByStepDialog () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/add-product-step-by-step/add-product-step-by-step.html?$$REVISION$$'
  }
}

export { addProductStepByStepDialog }
